/** Visuel section Acheter — public/images/Section_3/ */

export const SECTION3_IMAGE_DIR = '/images/Section_3';

export const SECTION3_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp'] as const;

/** Noms de fichier acceptés (première correspondance trouvée). */
export const SECTION3_IMAGE_BASENAMES = ['Section 3', 'Section_3', 'Acheter'] as const;

export const SECTION3_BACKGROUND_SRC = encodeURI(`${SECTION3_IMAGE_DIR}/Section 3.png`);

/** Fond Section 3 — mode clair. */
export const SECTION3_BACKGROUND_LIGHT_SRC = encodeURI(`${SECTION3_IMAGE_DIR}/Section 3 blanc.png`);

export const SECTION3_FALLBACK_IMAGE =
  'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80';

export const section3ImageSrc = (basename: string, ext: (typeof SECTION3_IMAGE_EXTENSIONS)[number]) =>
  encodeURI(`${SECTION3_IMAGE_DIR}/${basename}.${ext}`);
